import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bankList, memberBindBank, userAdd } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      bankList: [],
      form: {
        number: '',
        bindBank: ''
      },
      rules: {
        bindBank: [{
          require: true,
          validator: this.$tempModel.rules.money.validator,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    bankList({}).then(function _callee(res) {
      return regeneratorRuntime.async(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.bankList = res;

            case 1:
            case "end":
              return _context.stop();
          }
        }
      });
    });
  },
  methods: {
    show: function show(number, finish) {
      this.dialogVisible = true;
      this.form.number = number;
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          memberBindBank({
            number: _this2.form.number,
            recharge_bank: _this2.form.bindBank
          }).then(function _callee2(res) {
            return regeneratorRuntime.async(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this2.$message({
                      message: '操作成功',
                      type: 'success'
                    });

                    _this2.dialogVisible = false;

                    if (_this2.finish) {
                      _this2.finish();
                    }

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            });
          });
        }
      });
    }
  }
};